import { RefreshAccessToken } from "src/app/interfaces/Index";
import { AppSettingsService, AuthService } from "src/app/services/Index";
import { HandleAuthTokenRefreshTimer } from "./HandleAuthTokenRefreshTimer";
import { Timeout } from "./Timeout";

export const HandleAuthTokenRefresh = async() => {
	console.log("HandleAuthTokenRefresh")
	const accessToken = await AppSettingsService.get("accessToken");
	const refreshToken = await AppSettingsService.get("refreshToken");
	const refreshAccessToken = new RefreshAccessToken(accessToken, refreshToken);

	try {
		const res = await AuthService.refreshToken(refreshAccessToken);
		const json = (await res.json());
		if (!res.ok) throw new Error(json);
		console.log("Success")
		await AppSettingsService.set("accessToken", json.accessToken);
		await AppSettingsService.set("refreshToken", json.refreshToken);
		HandleAuthTokenRefreshTimer();
	} catch (e) {
		console.log("Failed")
		await Timeout(15000);
		console.log("Trying Again")
		await HandleAuthTokenRefresh();
	}
}